module.exports = __webpack_public_path__ + "static/kadikoy-5e077c93aef3c328dce8588102ba508e.webp";